import { FieldTypeEnum } from '@genesislcap/foundation-comms';
import { formatDateTimestamp, formatDateTimeTimestamp } from '@genesislcap/foundation-utils';
/**
 * Returns a filter type based on the Grid Pro field/column type.
 * @param type - The type of the field/column
 * @returns The ag-grid filter type
 * @remarks Currently only returns agTextColumnFilter
 * @alpha
 */
export function getFilterByFieldType(type) {
    switch (type) {
        // case 'int':
        // case 'long':
        // case 'double':
        // case 'bigdecimal':
        // case 'number':
        //   return 'agNumberColumnFilter';
        // case 'date':
        // case 'datetime':
        //   return 'agDateColumnFilter';
        default:
            return 'agTextColumnFilter';
    }
}
/**
 * Return a column type base on each field's metadata from the selected resource.
 * @param metadataType - The type of the field/column
 * @returns the column type
 * @remarks Currently only handles numeric columns
 * @alpha
 */
export function getColumnType(metadataType) {
    switch (metadataType === null || metadataType === void 0 ? void 0 : metadataType.toLowerCase()) {
        case 'int':
        case 'long':
        case 'double':
        case 'bigdecimal':
        case 'number':
            return 'numericColumn';
    }
}
/**
 * Returns the filter params based on the Grid Pro field/column type.
 * @param type - The type of the field/column
 * @returns the filter params for the specified field type
 * @remarks Currently only returns a default filter params object, for all field types
 * @alpha
 */
export function getFilterParamsByFieldType(type) {
    switch (type) {
        case FieldTypeEnum.DATE:
        case FieldTypeEnum.DATETIME: {
            return {
                comparator: function (filterLocalDateAtMidnight, cellValue) {
                    if (!cellValue)
                        return -1;
                    const cellValueTime = new Date(cellValue).setHours(0, 0, 0, 0);
                    const filterValueTime = filterLocalDateAtMidnight.getTime();
                    if (cellValueTime === filterValueTime) {
                        return 0;
                    }
                    if (cellValueTime < filterValueTime) {
                        return -1;
                    }
                    if (cellValueTime > filterValueTime) {
                        return 1;
                    }
                },
                buttons: ['reset', 'apply'],
                closeOnApply: true,
                closeOnClear: true,
                suppressAndOrCondition: true,
                browserDatePicker: true,
            };
        }
    }
}
/**
 * Returns a formatted date value from the Grid Pro cell value.
 * @param param - A ValueFormatterParams object.
 * @returns A formatted date value.
 * @public
 */
export function dateValueFormatter({ value }) {
    return formatDateTimestamp(value);
}
/**
 * Returns a formatted date time value from the Grid Pro cell value.
 * @param param - A ValueFormatterParams object.
 * @returns A formatted date time value.
 * @public
 */
export function dateTimeValueFormatter({ value }) {
    return formatDateTimeTimestamp(value);
}
// TODO: possible duplicate - need to evaluate the differences
const isoDateTimeSliceEnd = 19;
/**
 * Returns a formatted date value from an epoch number.
 * @param epoch - A number representing the number of milliseconds since the Unix epoch (1 January 1970 00:00:00 UTC).
 * @returns A formatted date value.
 * @alpha
 * @deprecated No longer used in the Grid Pro package.
 */
export function formatDateExtra(epoch) {
    return new Date(epoch)
        .toISOString()
        .slice(0, isoDateTimeSliceEnd)
        .replace(/-/g, '')
        .replace('T', '-');
}
/**
 * The time between allowing the grids to automatically resize.
 * @internal
 */
export const DEBOUNCED_RESIZE_TIME = 5;
